import http from '@/http'
import createCrudModule from 'vuex-crud'
import { withDataFilter } from '@/store/index'

const store = createCrudModule({
  client: http,
  resource: 'cameras',
  urlRoot: 'cameras',
  state: {
    total: 0
  },
  parseList(response) {
    return Object.assign({}, response, {
      data: response.data.data,
      total: response.data.total
    })
  },
  onFetchListSuccess(state, response) {
    state.total = response.total
  }
})

export default withDataFilter(store)
